import { Stack, Typography } from "@crayon/design-system-react";
import TextHeader from "components/primitives/TextHeader";
import { NotificationsIcon, UpdatesIcon } from "images/MuiIcons";
import NewsListNotifications from "./PartnerMigration/NewsListNotifications";

type NewsListMode = "Notifications" | "Updates";

interface INewsList {
  mode: NewsListMode;
}

const NewsList = ({ mode }: INewsList) => (
  <Stack spacing={2}>
    {mode === "Notifications" && (
      <TextHeader testId="page-header" label="Notifications" icon={<NotificationsIcon />} />
    )}
    {mode === "Updates" && (
      <TextHeader testId="page-header" label="Updates" icon={<UpdatesIcon />} />
    )}

    {mode === "Notifications" && <NewsListNotifications />}
    {mode === "Updates" && (
      <Typography variant="body2" align="justify">
        No updates
      </Typography>
    )}
  </Stack>
);

export default NewsList;
